module.exports = __webpack_public_path__ + "files/f8f4704bf9afb94d4725239356f76b5a.png";